import * as R from 'ramda'
import { isActionType } from 'helpers/ramda-ext/actions'
import * as Actions from 'store/actions'
import { RegisteredAction } from 'store/actions/index.types'
import { InitialState, State } from './lastViewedProducts.types'

const initialState: InitialState = {
  isFetched: false,
  products: []
}

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state: State = initialState, action: RegisteredAction): State => R.cond([
  [
    isActionType(Actions.lastViewedProducts.ON_FETCH_LAST_VIEWED_PRODUCTS_STARTED),
    R.always(R.assoc('isFetched', false, state))
  ], [
    isActionType(Actions.lastViewedProducts.LAST_VIEWED_PRODUCTS_FETCHED),
    R.pipe(
      R.always(R.assoc('isFetched', true, state)),
      R.assoc('products', R.prop('payload', action))
    )
  ], [
    isActionType(Actions.lastViewedProducts.FETCH_LAST_VIEWED_PRODUCTS_ERROR),
    R.always(R.assoc('isFetched', true, state))
  ], [
    R.T,
    R.always(state)
  ]
])(action)
